import React, { useRef, useEffect, useState, Suspense } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { Link } from "react-router-dom";
import "./banner.css";

import banner1 from "../assets/images/new_banner.jpg";
import coinTexture1 from "../assets/images/coin1.jpeg"; 
import coinTexture2 from "../assets/images/coin20.png";
import coinTexture3 from "../assets/images/coin2.jpeg"; 
import coinTexture4 from "../assets/images/coin5.jpg"; 

const slides = [
 {
  id: 1,
  image: banner1,
  subtitle: "Loanonsalary Instant Loan",
  title: "Your Salary, Your Financial Freedom",
  highlight: "Up to ₹50,000 Instantly",
  desc: "Experience seamless Ultra Short Term Loans with instant approval, zero hidden fees, and complete peace of mind."
 },
];

// 🪙 Generic Coin component
const Coin = ({ position, speed, texture }) => {
  const mesh = useRef();
  const coinTexture = new THREE.TextureLoader().load(texture);

  useFrame((state) => {
    if (!mesh.current) return;
    mesh.current.rotation.y += 0.02;
    mesh.current.rotation.x += 0.015;
    mesh.current.position.y += Math.sin(state.clock.elapsedTime * speed) * 0.005;
    mesh.current.position.x += Math.sin(state.clock.elapsedTime * speed * 0.5) * 0.002;
  });

  return (
    <mesh ref={mesh} position={position}>
      <cylinderGeometry args={[0.4, 0.4, 0.08, 48]} />
      <meshStandardMaterial map={coinTexture} metalness={1.0} roughness={0.25} />
    </mesh>
  );
};

// ✨ Floating coins — using multiple textures randomly
const FloatingCoins = () => {
  const textures = [coinTexture1, coinTexture2, coinTexture3, coinTexture4];

  const coins = Array.from({ length: 20 }).map(() => ({
    position: [
      (Math.random() - 0.5) * 8,
      (Math.random() - 0.5) * 5,
      (Math.random() - 0.5) * 3,
    ],
    speed: 0.6 + Math.random(),
    texture: textures[Math.floor(Math.random() * textures.length)],
  }));

  return (
    <>
      {coins.map((coin, i) => (
        <Coin key={i} position={coin.position} speed={coin.speed} texture={coin.texture} />
      ))}
    </>
  );
};

const Banner = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section
      className="banner-section fade-in"
      style={{ backgroundImage: `url(${slides[current].image})` }}
    >
      {/* Three.js background */}
      <div className="threejs-container">
        <Canvas camera={{ position: [0, 0, 5], fov: 55 }}>
          <ambientLight intensity={0.6} />
          <directionalLight position={[3, 3, 5]} intensity={1.2} color="#ffd27f" />
          <pointLight position={[-3, -2, -5]} intensity={0.8} color="#ffebc4" />
          <Suspense fallback={null}>
            <FloatingCoins />
          </Suspense>
        </Canvas>
      </div>

      {/* Overlay */}
      <div className="banner-overlay"></div>

      {/* Text Content */}
      <div className="banner-content">
        <h5 className="subtitle">{slides[current].subtitle}</h5>

        <h1 className="title">
          <span className="highlight">Your Salary</span>, Your Financial Freedom
          <br />
          Borrow up to{" "}
          <span className="highlight">{slides[current].highlight}</span>
        </h1>

        <p className="desc">{slides[current].desc}</p>
      </div>
    </section>
  );
};

export default Banner;
